import { kevinAuthAPI } from 'apis/config';

export const modelAPI = {
  getModelList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/model/${projectId}`)
      .then((res) => res.data),

  characterModelCreate: (projectId: string, data: any) =>
    kevinAuthAPI
      .post(`/resource-manager/model/${projectId}`, data)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  characterModelDelete: (projectId: number, model_id: number) =>
    kevinAuthAPI
      .delete(`/resource-manager/model/${projectId}/${model_id}`)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  modelUpdate: (projectId: number, model_id: number, data: any) =>
    kevinAuthAPI
      .put(`/resource-manager/model/${projectId}/${model_id}`, data)
      .then((res) => res.data),

  characterModelReset: (projectId: number, model_id: number) =>
    kevinAuthAPI
      .get(`/resource-manager/model/${projectId}/${model_id}`)
      .then((res) => res.data)
      .catch((err) => console.log(err)),

  // * 캐릭터 모델 zip 파일 업로드
  characterUploadZip: (projectId: string, model_id: string, data: any) =>
    kevinAuthAPI
      .post(`/resource-manager/model/${projectId}/${model_id}`, data)
      .then((res) => res.data)
      .catch((err) => console.log(err)),
  updateModelMotion: (projectId: any, model_id: number, data: any) =>
    kevinAuthAPI
      .patch(`/resource-manager/model/${projectId}/${model_id}`, data)
      .then((res) => res.data),
};
